export enum AccessUserType {
  Candidate = "candidate",
  Employee = "employee",
  Corporate = "corporate"
}
